import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../node_modules/font-awesome/css/font-awesome.min.css";
import { Link, useParams } from "react-router-dom";
import logo from "../assets/images/Artwork-Specific-Edition-Page-Auction/user-profile-icon-1.png";
import editIcon from "../assets/images/account-info/edit-profile-pic-icon.svg";
import img from "../assets/images/landing-page/collection-banner-carousel--collection-cover-art.png";
import plusIcon from "../assets/images/account-info/add-social-media-icon.svg";
import card1 from "../assets/images/Collection/artwork-1.png";
import card2 from "../assets/images/Collection/artwork-2.png";
import card3 from "../assets/images/Collection/artwork-3.png";
import { deployCollection } from "../blockchain/functions/functions";

const Mint = ({ prevStep, nextStep, handleChange, values }) => {
  let { id } = useParams();
  const [userAddress, setUserAddress] = useState("");
  const [collectionData, setCollectionData] = useState({
    name: "",
    description: "",
    image: "",
    items: [],
  });
  const [itemsUris, setItemsUris] = useState([]);
  const [amounts, setAmounts] = useState([]);
  const [prices, setPrices] = useState([]);
  const [auction, setAuction] = useState([]);

  const handleMint = async () => {
    let result = await deployCollection(itemsUris, prices, amounts, auction);
    if (result) {
      console.log(
        result.events.collectionDeployed.returnValues.newCollectionAddress
      );
      axios.get(
        `https://nfttest.xyz/nftapi/index.php/home/update_collection?collection_id=${id}&contract_address=${result.events.collectionDeployed.returnValues.newCollectionAddress}`
      );

      window.alert(
        `collection deployed at the address ${result.events.collectionDeployed.returnValues.newCollectionAddress}`
      );
    }
  };

  const connectWallet = async () => {
    try {
      console.log("hola");
      const accounts = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      setUserAddress(accounts[0]);

      const chainId = await window.ethereum.request({
        method: "eth_chainId",
      });

      if (chainId !== "0x4") {
        await window.ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: "0x4" }],
        });
      }
      console.log(chainId);

      window.ethereum.on("accountsChanged", function (accounts) {
        setUserAddress(accounts[0]);
      });

      window.ethereum.on("chainChanged", (_chainId) =>
        window.location.reload()
      );
    } catch (error) {
      console.log(error);
    }
  };

  const getCollectionDetails = async () => {
    console.log(id);
    if (id) {
      let details = await axios.get(
        `https://nfttest.xyz/nftapi/index.php/home/get_collections/${id}`
      );

      let colectionUris = [];
      let colectionamounts = [];
      let colectionprices = [];
      let colectionauction = [];
      details.data.items.map((item) => {
        colectionUris.push(
          `https://nfttest.xyz/nftapi/index.php/home/get_items/${item.id}`
        );
        colectionamounts.push(item.edition);
        colectionprices.push(item.price);
        let isAuction = false;
        if (item.sell_method === "bid") {
          isAuction = true;
        }
        colectionauction.push(isAuction);
      });

      console.log(details.data);
      setItemsUris(colectionUris);
      setAmounts(colectionamounts);
      setPrices(colectionprices);
      setAuction(colectionauction);
      setCollectionData(details.data);
    }
  };

  useEffect(() => {
    getCollectionDetails();
  }, []);

  return (
    <div className="main-wrapper">
      {/* Header area start */}
      <nav className="navbar navbar-light justify-content-between">
        <Link to="/" className="navbar-brand">
          <img src={logo} alt="logo" /> Lorem
        </Link>
        <div className="justify-content-between">
          {/* <Link to="#"><i className="fa fa-search" aria-hidden="true"></i></Link>&emsp;
                    <Link to="/Drops">Drops</Link>&emsp;
                    <Link to="/Marketplace">Marketplace </Link> */}
          <div className="dropdown">
            <button className="dropbtn">
              <i className="fa fa-user" aria-hidden="true"></i>
            </button>
            <div className="dropdown-content text-left">
              <Link to="/AccountInfo">Account Info</Link>
              <Link to="#">Account Activity</Link>
              <Link onClick={connectWallet} to="#">
                {!userAddress
                  ? "Connect Wallet"
                  : `${userAddress.slice(0, 5)}...${userAddress.slice(-5)}`}
              </Link>
              <Link to="/UserProfileBuyer">Buyer Profile</Link>
              <Link to="/CollectionDetails">Add New Collections</Link>
              <Link to="/LoginSignup">Login</Link>
            </div>
          </div>
        </div>
      </nav>
      {/* Header area end */}

      {/* Form area start */}
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10 text-center form-area">
            {/* <h1 className="text-center">Submit New Collection</h1> */}

            {/* Progressbar start */}
            {/* <ul id="progress-bar" className="progressbar">
              <li className="active">COLLECTION</li>
              <li className="active">UPLOAD ITEMS</li>
              <li className="active">ITEM DETAILS</li>
              <li className="active">REVIEW & SUBMIT</li>
            </ul> */}
            {/* Progressbar end */}
          </div>
        </div>
      </div>

      {/* multistep form start*/}
      <div
        className="container text-center margin-70 arrow"
        style={{ justifyContent: "center" }}
      >
        {/* <button onClick={Previous}>&#10229;</button> */}
        <h1>Mint Your Collection</h1>
        {/* <button>
          <Link to="/Submitted">Submit</Link>
        </button> */}
      </div>
      <div className="container mb-5 text-center">
        <div className="row justify-content-center">
          <div className="col-lg-8 review-area">
            <h1>Collection Title</h1>
            <h6>{collectionData.name}</h6>
            <h1>Description</h1>
            <p>1000 of 1000 characters used</p>
            <h6>{collectionData.description}</h6>
            <h4>Collection Cover Art</h4>
            <img src={collectionData.image} alt="" className="review-banner" />
            <h4>
              {collectionData.items.length} Items in this Collection{" "}
              <img src={plusIcon} alt="" />{" "}
            </h4>
          </div>
        </div>
        <div className="row review-card justify-content-center">
          {collectionData.items.length > 0 &&
            collectionData.items.map((item) => {
              let { id, edition, images, item_title, price, sell_method } =
                item;
              return (
                <div key={id} className="card text-left">
                  <img
                    src={`https://nfttest.xyz/nftapi/${images}`}
                    className="card-img-top"
                    alt=""
                  />
                  <div className="card-body">
                    <h3>{item_title}</h3>
                    <h3>{price} ETH</h3>
                    <h3>{sell_method === "bid" ? "Auction" : "Fixed Price"}</h3>
                    <h6 className="card-text">
                      <small>{edition} editions</small>
                    </h6>
                  </div>
                </div>
              );
            })}
        </div>
        {collectionData.contract_address ? (
          <h1>Collection already minted</h1>
        ) : (
          <button onClick={handleMint}>Mint</button>
        )}
      </div>
      {/* multistep form end*/}
      {/* Form area end */}
    </div>
  );
};

export default Mint;
